module.exports = __webpack_public_path__ + "media/images/leadmatick_blue-994435ea97f7dafcf8e497fa5f7671a9.png";